import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';
import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconStarFilled } from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HomefieldProductBadgeComponent } from './product-badge.component';

@NgModule({
	imports: [
		CommonModule,
		HomefieldIconLibraryModule
	],
	declarations: [HomefieldProductBadgeComponent],
	exports: [HomefieldProductBadgeComponent]
})
export class HomefieldProductBadgeModule {
	//eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
	constructor(private resolver: ComponentFactoryResolver, HomefieldIconsLibraryService: HomefieldIconsLibraryService) {
		HomefieldIconsLibraryService.registerIcons([homefieldIconStarFilled]);
	}

	public resolveComponentFactory(): ComponentFactory<HomefieldProductBadgeComponent> {
		return this.resolver.resolveComponentFactory(HomefieldProductBadgeComponent);
	}
}
